import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useStore from "../../lib/store";
import { getBufferRoute } from "../../lib/navigation";

const BufferLine = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    buffers,
    activeBuffer,
    openBuffer,
    setActiveBuffer,
    closeBuffer,
    openSearch,
    keyboardNav,
  } = useStore();

  const handleTabClick = (buffer) => {
    const route = getBufferRoute(buffer);
    openBuffer(buffer);
    if (location.pathname !== route) {
      navigate(route);
    } else {
      setActiveBuffer(buffer);
    }
  };

  const handleClose = (e, buffer) => {
    e.stopPropagation();
    const nextActive =
      activeBuffer === buffer
        ? undefined
        : activeBuffer;
    closeBuffer(buffer);
    if (nextActive === undefined) {
      // Focus the previous buffer
      const s = useStore.getState();
      navigate(getBufferRoute(s.activeBuffer));
    }
  };

  return (
    <nav className="bufferline" aria-label="Open buffers">
      {buffers.map((buffer) => (
        <button
          key={buffer}
          type="button"
          className={
            "bufferline-tab" + (buffer === activeBuffer ? " active" : "")
          }
          onClick={() => handleTabClick(buffer)}
        >
          <span className="bufferline-label">{buffer}</span>
          {!keyboardNav && (
            <span
              className="bufferline-close"
              onClick={(e) => handleClose(e, buffer)}
              role="button"
              tabIndex={-1}
              aria-label={`Close ${buffer}`}
            >
              ×
            </span>
          )}
        </button>
      ))}
      <button
        type="button"
        className="bufferline-search"
        onClick={openSearch}
        aria-label="Search (Ctrl+P)"
        title="Search (Ctrl+P)"
      >
        /
      </button>
    </nav>
  );
};

export default BufferLine;